import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import BreadCrumbComp from "../../components/BreadCrumbComp";
import LoaderComp from "../../components/LoaderComp";
import StatsBoard from "../../components/StatsBoard";
import API from "../../utils/api";
import classes from "./StatsDetail.module.css";

export default function StatsDetail() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchStats = async () => {
    try {
      setLoading(true);
      setError("");
      const response = await fetch(`${API.base}/site_stats.php`);
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.error || "Failed to load stats");
      }
      setStats(data);
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return (
    <>
      <Helmet>
        <title>Data Detail | Prime Cloud Systems</title>
      </Helmet>

      <BreadCrumbComp
        currentPage="Data Detail"
        title="Prime Cloud Systems Data Detail"
        description="View detailed information on Prime Cloud Systems IT hardware, networking equipment, and enterprise solutions. Access specifications, features, and insights to make informed decisions for your business."
      />

      <div className={classes.page}>
        {loading ? (
          <LoaderComp />
        ) : error ? (
          <div className={classes.errorCard}>
            <p>{error}</p>
            <button type="button" onClick={fetchStats}>
              Retry
            </button>
          </div>
        ) : (
          <StatsBoard
            counts={stats?.counts}
            importSummary={stats?.import_summary}
            recentRuns={stats?.recent_runs}
            generatedAt={stats?.generated_at}
            title="Product Data Detail"
            subtitle="Live overview of catalog volume and import runs."
          />
        )}
      </div>
    </>
  );
}
